module.exports = __webpack_public_path__ + "img/verify.55233d0a.svg";